/**
 * Tarayıcı tarafı yetki yardımcıları.
 *
 * ⚠️ **Bunlar GÜVENLİK DEĞİLDİR.** Buradaki kontroller yalnızca kullanıcıyı
 * yapamayacağı bir işe girişmekten korur (düğmeyi gizler, menüyü kısar).
 * Gerçek kilit sunucuda: her uç `requirePermission` çağırır
 * (src/panel/guard.ts). Tarayıcıdaki JavaScript'i herkes değiştirebilir.
 *
 * İzin anahtarları sunucudan gelir; burada liste TUTULMAZ. Tek kaynak
 * `src/panel/permissions.ts` — iki yerde ayrı liste, birinin güncellenip
 * diğerinin unutulmasıyla sonuçlanır.
 */

import type { Kullanici } from './api';

/** Kullanıcının bu izni var mı? */
export function izinVar(kullanici: Kullanici | null | undefined, izin: string): boolean {
  if (!kullanici) return false;
  // Süper Yönetici her izne sahiptir; sunucu da böyle hesaplıyor.
  if (kullanici.isSuperAdmin) return true;
  return kullanici.permissions.includes(izin);
}
